import React from 'react'
import PropTypes from 'prop-types'
import { withRouter } from 'react-router'
import { injectIntl, defineMessages } from 'react-intl'
import { compose } from 'recompose'
import { Link } from 'react-router-dom'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { Button, TextInput } from '../components'

export default function withNameInput(WrappedComponent) {
  class FormWithInput extends React.Component {
    constructor(props) {
      super(props)
      this.state = {
        name: '',
        error: '',
        confirmedName: false,
      }
    }

    confirmName() {
      const { intl } = this.props

      if (this.state.name) {
        this.setState({
          confirmedName: true,
          error: '',
        })
      } else {
        this.setState({
          error: intl.formatMessage(messages.invalidInput),
        })
      }
    }

    render() {
      const { name, confirmedName, error } = this.state
      const {
        intl,
        lesson,
        test,
        group,
        homework,
        isTestCreateForm,
        isHomeworkCreateForm,
        nameAsPopup,
        label,
        closeLink,
        history,
        description,
      } = this.props

      const showAsPopup = isTestCreateForm || isHomeworkCreateForm || nameAsPopup
      const isEdit = lesson || test || group || homework

      return (
        <div>
          {
            !confirmedName && !isEdit &&
            <div className={showAsPopup ? 'popup-wrapper' : ''}>
              <div className={showAsPopup ? 'popup-content' : ''}>
                {
                  showAsPopup &&
                  <header>
                    {
                      closeLink ?
                        <Link
                          to={closeLink}
                          className="popup-wrapper-close"
                        >
                          <FontAwesomeIcon icon="times-circle" size="2x" />
                        </Link>
                      :
                        <div
                          className="popup-wrapper-close"
                          onClick={() => history.goBack()}
                        >
                          <FontAwesomeIcon icon="times-circle" size="2x" />
                        </div>
                    }
                  </header>
                }
                <div className="name-input-wrapper">
                  <h2>{label || intl.formatMessage(messages.createexercise)}</h2>
                  {
                    description &&
                    <p>{description}</p>
                  }
                  <TextInput
                    value={name}
                    onChange={(e) => this.setState({ name: e.target.value })}
                    label={intl.formatMessage(messages.name)}
                    className="width-full"
                    placeholder={intl.formatMessage(messages.enterName)}
                  />
                  {
                    error &&
                    <p className="message negative">{error}</p>
                  }
                  <div className="block-center">
                    <Button
                      positive
                      className="vertical-spacing"
                      onClick={() => this.confirmName()}
                    >
                      {intl.formatMessage(messages.continue)}
                    </Button>
                  </div>
                </div>
              </div>
            </div>
          }
          {
            (confirmedName || isEdit) &&
            <WrappedComponent
              name={name}
              {...this.props}
            />
          }
        </div>
      )
    }
  }

  FormWithInput.defaultProps = {
    isTestCreateForm: false,
    isHomeworkCreateForm: false,
    nameAsPopup: false,
    lesson: null,
    test: null,
    group: null,
    homework: null,
    label: '',
    description: '',
    closeLink: '',
  }

  FormWithInput.propTypes = {
    intl: PropTypes.object.isRequired,
    history: PropTypes.object.isRequired,
    lesson: PropTypes.object,
    test: PropTypes.object,
    group: PropTypes.object,
    homework: PropTypes.object,
    isTestCreateForm: PropTypes.bool,
    isHomeworkCreateForm: PropTypes.bool,
    nameAsPopup: PropTypes.bool,
    label: PropTypes.string,
    description: PropTypes.string,
    closeLink: PropTypes.string,
  }

  const enhance = compose(
    withRouter,
    injectIntl,
  )

  return enhance(FormWithInput)
}

const messages = defineMessages({
  name: {
    id: 'withNameInput.name',
    defaultMessage: 'Názov',
  },
  enterName: {
    id: 'withNameInput.enterName',
    defaultMessage: 'Zadajte názov',
  },
  continue: {
    id: 'withNameInput.continue',
    defaultMessage: 'Pokračovať',
  },
  createexercise: {
    id: 'withNameInput.createexercise',
    defaultMessage: 'Vytvoriť cvičenie',
  },
  invalidInput: {
    id: 'withNameInput.invalidInput',
    defaultMessage: 'Názov nesmie byť prázdny.',
  },
})



// WEBPACK FOOTER //
// ./src/browser/components/withNameInput.js